import React, { Fragment, CSSProperties, useState } from "react";
import { store } from "../../stateManager";
import styled from "styled-components";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { GrDuplicate } from "react-icons/gr";
import { Icon } from "antd";
import {
  removeComponentFromJson,
  removeComponentsAndAdd,
  addFormJson,
  updateFormProperties,
  ungroup,
} from "../../stateManager/store/formCreation/action";
import { setContextMenuVisibility, clearSelectedItems } from "../../stateManager/store/contextMenu/action";
import { PUSH_ACTION_STACK } from "../../stateManager/store/formCreation/types";
import { getRandomId } from "../../utils/random-id";
import { findIdSelector } from "../../pages/apps/Assisted/forms/create/reduxSelector";
import { validateFormJson } from "../../utils/validate-form-json";
import { generateId, generateSectionalIds, getCardContainer, useToast, encodeBase64, populateFields } from "../commonFunction";
import { logger } from "../../constant/winston";
import { components } from '../../pages/apps/Assisted/forms/create/rendererJson'
import { fCardSelect } from '../RxServices'
import "./styles/context-menu.scss";
import { Http } from "../axois";
import { addAssets } from "../../stateManager/store/assets/action";

const StyledContextMenu = styled.div`
  position: absolute;
  top: ${(props: any) => props.theme.top + "px"};
  left: ${(props: any) => props.theme.left + "px"};
  z-index: 99999;
  width: 160px;
  color: inherit;
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid #1890ff;
  background-color: #fff;
  font-size: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
`;

const iconStyle: CSSProperties = {
  fontSize: 16,
  marginRight: 8,
  position: "relative",
  bottom: 4,
};

export const ContextMenu = () => {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const [hideContext, setHideContext] = useState<boolean>(false);

  const visibility = useSelector((state: any) => state.contextMenu.visibility)
  const selectedItemId = useSelector((state: any) => state.contextMenu.selectedItemId)
  const selectedItemsId = useSelector((state: any) => state.contextMenu.selectedItemsId)
  const isMultipleSelection = useSelector((state: any) => state.contextMenu.isMultipleSelection)
  const coordinates = useSelector((state: any) => state.contextMenu.coordinates)
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [isNestedAsset, setIsNestedAsset] = useState(false);

  const forms = useSelector((state: any) => state.formcreation);
  const params: any = useParams();
  const form = forms[params.formId];

  fCardSelect.getMessage().subscribe((res: any) => {
    if (res.id && res.json) {
      setSelectedItem(res.json)
      setHideContext(res.json.isChildAsset)
    } else {
      setSelectedItem({})
    }
  })

  const getTypeFromId = (id: string) => {
    const tokens = id.split("#");
    return tokens[tokens.length - 1].split("-")[0];
  };

  const hideMenu = () => {
    dispatch(
      setContextMenuVisibility({
        visibility: false,
        coordinates: {},
      })
    );
  };

  const shouldPaste = () => {
    const type = getTypeFromId(selectedItemId);
    return type === "section" || type === "container";
  };

  const deleteCard = (selectedItemId: string) => {
    const cardContainer = getCardContainer(selectedItemId, params.formId);

    dispatch({
      type: PUSH_ACTION_STACK,
      data: {
        undo: () => {
          dispatch(
            removeComponentFromJson(
              {
                formid: params.formId,
                draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
                itemId: selectedItemId,
              },
              true
            )
          );
        },
        redo: () => {
          dispatch(
            removeComponentFromJson({
              formid: params.formId,
              draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
              itemId: selectedItemId,
            })
          );
        },
      },
    });

    dispatch(
      removeComponentFromJson({
        formid: params.formId,
        draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
        itemId: selectedItemId,
      })
    );

    hideMenu();
  };

  const handleAsset = () => {
    const newAssetId = getRandomId()
    const assetInstanceId = getRandomId()
    const assetBindPrefix = getRandomId()

    // data that needs to be updated in redux store
    const data: any = {
      isAsset: true,
      assetId: newAssetId,
    }

    const selectedItem = JSON.parse(JSON.stringify(getSelectedItem(selectedItemId)))
    selectedItem?.fields?.forEach((item: any) => {
      if (item.type === "asset") {
        item.parentAssetId = newAssetId
      }
    })
    // the assetPayload should not contain the bind prefixes as it is the source itself
    let assetPayload = JSON.parse(JSON.stringify(getSelectedItem(selectedItemId)))

    if (selectedItem && (selectedItem.type === "Container" || selectedItem.type === "Section")) {
      // asset instance
      populateFields(selectedItem.fields, { isAsset: true, assetId: newAssetId })
      // asset payload
      populateFields(assetPayload.fields, { isAsset: true, assetId: newAssetId })
    }

    // update the form source
    dispatch(
      updateFormProperties({
        formid: params.formId,
        id: selectedItemId,
        data: {
          ...data,
          assetInstanceId,
          assetBindPrefix,
          fields: selectedItem.fields,
        }
      })
    );

    // update the PropertiesPanel
    fCardSelect.sendMessage({
      id: selectedItemId,
      json: {
        ...selectedItem,
        ...data,
        assetInstanceId,
        assetBindPrefix,
      }
    });

    hideMenu()

    // api call
    assetPayload = {
      ...assetPayload,
      ...data,
    }

    const payload = {
      assetId: newAssetId,
      label: assetPayload.properties.label || assetPayload.label,
      source: encodeBase64(JSON.stringify(assetPayload))
    }

    Http.post(`/orgs/${orgId}/assets`, payload).subscribe((res: any) => {
      if (res.ok) {
        dispatch(addAssets({
          assetId: payload.assetId,
          label: payload.label,
          json: assetPayload,
          id: res.data.id,
        }))
        SuccessToast("Asset added");
      } else {
        logger.error(res);
        ErrorToast("Unable to add asset");
      }
    })
  }

  const getSelectedItem = (widgetId: string) => {
    const paths = widgetId.split("#");
    let field = form;

    paths.forEach((path, index) => {
      const fieldId = index === 0 ? path : paths.slice(0, index + 1).join("#");
      const found = field.find((field: any) => field.id === fieldId);
      if (found) {
        field = index === paths.length - 1 ? found : found.fields;
      }
    });

    return field;
  }

  // context menu handlers
  const handleDeleteCard = () => {
    if (selectedItemId) {
      deleteCard(selectedItemId);
      SuccessToast("Successfully deleted");
    } else {
      ErrorToast("Failed to delete");
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(selectedItem))
      SuccessToast("Copied to clipboard");
      hideMenu();
    } catch (err) {
      console.error("failed to copy text: ", err);
    }
  };

  const handlePaste = async () => {
    try {
      const clipboardData = await navigator.clipboard.readText();
      const data = JSON.parse(clipboardData)
      const selectedItem = JSON.parse(JSON.stringify(getSelectedItem(selectedItemId)))
      const isValid: boolean = validateFormJson(data);
      if (!isValid) {
        ErrorToast("Invalid form json");
        return;
      }

      // const cardContainer = getCardContainer(selectedItemId);
      const newId = generateId({ json: data }, { json: selectedItem });
      const updatedData = generateSectionalIds({ json: data }, newId, { isDynamic: true });
      updatedData.elementId = getRandomId();

      dispatch(
        addFormJson({
          formId: params.formId,
          data: updatedData,
        })
      );

      hideMenu();
    } catch (err) {
      ErrorToast("Invalid json");
      logger.error(err);
      hideMenu();
    }
  };

  const handleDuplicate = () => {
    const cardContainer = getCardContainer(selectedItemId, params.formId);
    const newId = generateId({ json: selectedItem }, { json: cardContainer });
    const updatedData = generateSectionalIds({ json: selectedItem }, newId, { isDynamic: true });
    updatedData.elementId = getRandomId();

    dispatch(
      addFormJson({
        formId: params.formId,
        data: updatedData,
      })
    );

    hideMenu();
  }

  const handleGroup = () => {
    // 1. get the container in which we are going to place the group
    const field = selectedItem.isGroup ? selectedItem.id : selectedItemsId[0]
    const state = store.getState();
    const cardIdSplit = field.split('#');
    cardIdSplit.pop()

    const cardContainer = findIdSelector(state, params.formId, cardIdSplit, true)
    const fieldItem = getSelectedItem(field)

    // 2. creating the group
    const groupedFields = selectedItemsId.map((id: string) => {
      const item = getSelectedItem(id)
      return {
        ...item,
        properties: {
          ...item.properties,
          layout: { parent: "column", widthMode: "fill" }
        }
      }
    })

    let container = fieldItem.isGroup ? fieldItem : components.basic.find((el: any) => el.id === "container")

    const containerId = generateId(fieldItem.isGroup ? { json: container } : container, { json: cardContainer })
    const containerFields = fieldItem.isGroup
      ? [
        ...container.fields,
        ...groupedFields.filter((el: any) => el.id !== fieldItem.id),
      ]
      : groupedFields;

    if (!fieldItem.isGroup) {
      container = {
        ...container.json,
        label: "Container",
        isGroup: true,
      }
    }
    container.fields = containerFields;
    container.properties.layout.direction = "column"

    const group = generateSectionalIds({ json: container }, containerId, { isDynamic: true });
    group.elementId = getRandomId();

    // 3. structure the params for action creator
    const addData = {
      formId: params.formId,
      data: group,
    }
    const data = {
      formId: params.formId,
      selectedItemsId
    }
    dispatch(removeComponentsAndAdd(data, addData))

    // 4. Hide the menu and clear selection
    hideMenu();
    dispatch(clearSelectedItems())
  }

  const handleUnlink = () => {
    let itemCopy = JSON.parse(JSON.stringify(selectedItem))

    // data that needs to be updated in redux store
    const data: any = {
      isAsset: false,
      assetId: "",
      assetInstanceId: "",
      assetBindPrefix: "",
    }

    if (itemCopy && (itemCopy.type === "Container" || itemCopy.type === "Section")) {
      populateFields(itemCopy.fields, { isAsset: false, assetId: "", assetInstanceId: "", isChildAsset: false }, true)
      data.fields = itemCopy.fields
    }

    itemCopy = {
      ...itemCopy,
      ...data
    }

    // update the form source
    dispatch(
      updateFormProperties({
        formid: params.formId,
        id: selectedItemId,
        data
      })
    );

    // update PropertiesPanel
    fCardSelect.sendMessage({
      id: selectedItemId,
      json: itemCopy,
    })

    hideMenu()
  }

  const handleUngroup = () => {
    // 1. get the group fields and the group parent
    const cardContainer = JSON.parse(JSON.stringify(getCardContainer(selectedItemId, params.formId)))
    const groupFields = selectedItem.fields

    // 2. generate new IDs for group fields based on the group parent container
    const updatedGroupFields = groupFields.map((field: any) => {
      const newId = generateId({ json: field }, { json: cardContainer });
      const updatedData = generateSectionalIds({ json: field }, newId);
      updatedData.elementId = getRandomId();
      delete updatedData.properties.layout;
      cardContainer.fields.push(updatedData)
      return updatedData;
    })

    // 3. add the newly generated fields and remove the container
    dispatch(
      ungroup({
        fields: updatedGroupFields,
        formId: params.formId,
        containerId: selectedItemId,
      })
    );
    hideMenu()
  }

  React.useEffect(() => {
    if (selectedItem) {
      let ids: any[] = selectedItem?.id?.split("#")
      if (ids?.length > 0) {
        ids.map((item: string) => {
          if (item.includes("asset")) {
            setIsNestedAsset(true)
          } else {
            setIsNestedAsset(false)
          }
        })
      }
    }
  }, [ selectedItem ])

  return (
    <Fragment>
      {!hideContext && !isNestedAsset && visibility && selectedItemId ? (
        <StyledContextMenu theme={coordinates}>
          <ul className="contextMenuWrapper">
            {selectedItemId && !isMultipleSelection && (
              <li id="contextMenuItem" onClick={handleDuplicate}>
                <GrDuplicate style={iconStyle} /> Duplicate
              </li>
            )}

            {selectedItemId && !isMultipleSelection && (
              <li id="contextMenuItem" onClick={handleCopy}>
                <Icon type="copy" style={iconStyle} /> Copy
              </li>
            )}

            {shouldPaste() && <li id="contextMenuItem" onClick={handlePaste}>
              <Icon type="plus" style={iconStyle} /> Paste
            </li>}

            {selectedItemId && !isMultipleSelection && !(selectedItem.isAsset) && (
              <li id="contextMenuItem" onClick={handleAsset}>
                <Icon type="crown" style={iconStyle} /> Asset
              </li>
            )}

            {selectedItemId && !isMultipleSelection && selectedItem.isAsset && (
              <li id="contextMenuItem" onClick={handleUnlink}>
                <Icon type="api" style={iconStyle} /> Unlink
              </li>
            )}

            {isMultipleSelection && selectedItemsId.length >= 2 && (
              <li id="contextMenuItem" onClick={handleGroup}>
                <Icon type="snippets" style={iconStyle} /> Group
              </li>
            )}

            {selectedItem && !isMultipleSelection && selectedItem.isGroup && (
              <li id="contextMenuItem" onClick={handleUngroup}>
                <Icon type="disconnect" style={iconStyle} /> Ungroup
              </li>
            )}

            {selectedItemId && !isMultipleSelection && (
              <li id="contextMenuItem" onClick={handleDeleteCard}>
                <Icon type="delete" style={iconStyle} /> Delete
              </li>
            )}
          </ul>
        </StyledContextMenu>
      ) : null}
    </Fragment>
  );
};
